import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { AxiosRepository } from './axios.repository';
import { IAttachmentsUpdate, IDocument, IOnboardingRepository, IOnboardingUpdate } from '@common/interfaces';

class OnboardingRepository extends AxiosRepository implements IOnboardingRepository {
  public constructor(protected authClient: AxiosInstance) {
    const client = axios.create()
    client.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_API_VERSION}`;

    super(client, authClient);
  }

  async getCountries() {
    const { data } = await this.get('/countries/?limit=300');
    return data;
  }

  async getFocalPoints(id: string) {
    const { data } = await this.get(`/onboarding_requests/${id}/focal-points/`);
    return data;
  }

  async getOnboardingInit() {
    const { data } = await this.get('/onboarding_requests/initialization/');
    return data;
  }

  async getOrganisationCategories() {
    const { data } = await this.get(`${process.env.REACT_APP_HBH_API_URL}/agencies/organisation-categories/`);
    return data;
  }

  async getRequestedDocumentsConfig(countryCode: string, category: number) {
    const { data } = await this.get<{ results: IDocument[] }>(`/requested-documents-configs/?category=${category},-1`, {
      params: {
        country_iso_code: countryCode,
        is_visible: true,
      },
    });
    return data;
  }

  async updateOnboarding(payload: IOnboardingUpdate) {
    payload.director_and_fp_info?.forEach(element => {
      element.role = element.role.toUpperCase();
    })

    const { data } = await this.post('/onboarding_requests/', payload);
    return data;
  }

  async updateFile(id: string, docId: string, payload: IAttachmentsUpdate) {
    const formData = new FormData();
    formData.append('config_type', payload.config_type);
    if (payload.file) formData.append('_file', payload.file);

    const { data } = await this.patch(`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_API_VERSION}/onboarding_requests/${id}/documents/${docId}/`, formData);

    return await data;
  }

  async uploadFile(id: string, payload: IAttachmentsUpdate) {
    const formData = new FormData();
    formData.append('config_type', payload.config_type);
    if (payload.file) formData.append('_file', payload.file);

    const { data } = await this.post(`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_API_VERSION}/onboarding_requests/${id}/documents/`, formData);

    return await data;
  }
}

export default OnboardingRepository;
